export default {
    created: "Conversatia WhatsApp a fost creata cu succes.",
    updated: "Conversatia WhatsApp a fost actualizata cu succes.",
    deleted: "Conversatia WhatsApp a fost stearsa cu succes.",
    restored: "Conversatia WhatsApp a fost restaurata cu succes.",
    message_sent: "Mesajul a fost trimis cu succes.",
}
